import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import React from "react";

const renderOption = (artist) => {
    return (
        <MenuItem key={artist.ArtistID} value={artist.ArtistID}>{artist.Kuerzel}</MenuItem>
    )
}

const filterArtist = (artist, tatortID, ausgeschiedene) => artist &&
    (!ausgeschiedene && artist.StdOrtID === +tatortID && !artist.Ausgeschieden
        || ausgeschiedene && artist.Ausgeschieden)

export const renderOptionGroup = ({artistsMap, tatortMap, tatortID, ausgeschiedene, key, excludeArtistIds}) => {
    const label = ausgeschiedene ? 'Ausgeschiedene' : tatortMap[tatortID]?.Ort || tatortID
    const excludeSet = excludeArtistIds ? new Set(excludeArtistIds) : null
    const artists = Object.values(artistsMap)
        .filter(a => {
            if (excludeSet && excludeSet.has(a.ArtistID)) {
                return false
            }
            return filterArtist(a, tatortID, ausgeschiedene)
        })
        .sort((a1, a2) => a1.Kuerzel > a2.Kuerzel ? 1 : -1)
    if (!artists.length) {
        return null
    }
    const options = artists.map(artist => renderOption(artist))
    return [
        <ListSubheader key={key}>{label}</ListSubheader>
        , options
    ]
}

export const renderRecentOptionGroup = ({artistsMap, recentArtistIds, label, key}) => {
    if (!recentArtistIds || !recentArtistIds.length) {
        return null
    }
    const artists = recentArtistIds
        .map(id => artistsMap[id])
        .filter(artist => artist && !artist.Ausgeschieden)
        .sort((a1, a2) => a1.Kuerzel > a2.Kuerzel ? 1 : -1)
    if (!artists.length) {
        return null
    }
    const options = artists.map(artist => renderOption(artist))
    return [
        <ListSubheader key={key}>{label}</ListSubheader>
        , options
    ]
}